import axios from 'axios';
// import isEmpty from 'lodash/fp/isEmpty';
import isEqual from 'lodash/fp/isEqual';

// Mutations
export const SET_PARAMS = 'SET_PARAMS';
export const INVALIDATE = 'INVALIDATE';
export const INIT_REQUEST = 'INIT_REQUEST';
export const RECORD_FETCH_ERROR = 'RECORD_FETCH_ERROR';
export const RECORD_FETCH_RESULTS = 'RECORD_FETCH_RESULTS';

const mutations = {
    [SET_PARAMS] (state, params) {
        state.params = params;
    },

    [INVALIDATE] (state) {
        state.req = null;
    },

    [INIT_REQUEST] (state) {
        state.req = {
            pending: true
        };
    },

    [RECORD_FETCH_ERROR] (state, error) {
        console.error("FETCH ERROR", error);

        state.req = {
            error
        };
    },

    [RECORD_FETCH_RESULTS] (state, results) {
        state.req = {
            results,
            pending: false
        };
    }
};

export function createFetchModule({url, method}, changeAction) {
    return {
        namespaced: true,

        state: () => ({
            params: {},
            req: null
        }),

        getters: {
            results: state => state.req && state.req.results || null,
            pending: state => state.req && state.req.pending,
            error: state => state.req && state.req.error,
            fetchNeeded: (_, getters) => !getters.results && !getters.pending && !getters.error
        },

        mutations,

        actions: {
            fetch: function(store, params) {
                if (typeof params != 'undefined') store.dispatch('setParams', params);

                // Dispatch a fetch unless we already have results or a pending request.
                // Note that, if SET_PARAMS was just committed, a new fetch request will be started for the new query.
                if (store.getters.fetchNeeded) {
                    store.dispatch('reload');
                }
            },

            setParams({ state, commit, dispatch }, params) {
                // If the query is different from the one previously stored,
                // then store the new one. This invalidates any prior results or requests.
                if (!isEqual(state.params, params)) {
                    commit(SET_PARAMS, params);
				}
                dispatch('invalidate'); // Ric: Moved this out of if due to cacheing
            },

            invalidate({ commit, dispatch }) {
                commit(INVALIDATE);
                dispatch('emitChange');
            },

            // Start a new fetch request (req)
            async reload({ state, commit, dispatch }) {
                // Register a pending req object in the store and get a reference to it.
                commit(INIT_REQUEST);
                dispatch('emitChange');
                const req = state.req;

                try {
                    // Query the API server and wait for the response.
                    let res;

                    if (method == 'post') {
                        res = await axios.post(url, {
                            data: state.params,
							headers: { 'Cache-Control': 'no-cache' }
                        });
                    } else {
                        // console.log("Getting from api " + url + " " + JSON.stringify(state.params));
                        res = await axios.get(url, {
                            params: state.params,
							headers: { 'Cache-Control': 'no-cache' }
                        });
                    }

                    // Make sure that our req object is still identically equal to the most recent stored req.
                    if (req === state.req) {
                        // console.log('response:', res);

                        if (res && res.status == 200 && res.data) {
                            commit(RECORD_FETCH_RESULTS, res.data);
                            dispatch('emitChange');
                        } else {
                            throw new Error("Invalid response");
                        }
                    } else {
                        // If a new req was started while this one was waiting for the API, we discard this one.
                        console.warn("discarding a req because another was started in the meantime");
                    }
                }
                catch (e) {
                    if (req === state.req) {
                        commit(RECORD_FETCH_ERROR, e);
                        dispatch('emitChange');
                    }
                }

                return state.req;
            },

            // Parent store modules can listen for changes by specifying a changeAction to be run on each state change
            emitChange({state, dispatch}) {
                if (changeAction) {
                    dispatch(changeAction, state.req, { root: true });
                }
            }
        }
    };
};
